var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hide)?_c('div',_vm._g({staticClass:"multiselect__caret"},_vm.$listeners),[_c('font-awesome-icon',{attrs:{"icon":[_vm.solid ? 'fas' : 'fal', 'chevron-down'],"size":"xs"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }